/**
 * @flow
 * @relayHash 6e9d8cbf0d663471973bb3b4e869492d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteJobInput = {|
  id: string
|};
export type DeleteJobMutationVariables = {|
  input: DeleteJobInput
|};
export type DeleteJobMutationResponse = {|
  +deleteJob: {|
    +deletedId: string
  |}
|};
export type DeleteJobMutation = {|
  variables: DeleteJobMutationVariables,
  response: DeleteJobMutationResponse,
|};
*/


/*
mutation DeleteJobMutation(
  $input: DeleteJobInput!
) {
  deleteJob(input: $input) {
    deletedId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteJobInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteJob",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteJobPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteJobMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteJobMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteJobMutation",
    "id": null,
    "text": "mutation DeleteJobMutation(\n  $input: DeleteJobInput!\n) {\n  deleteJob(input: $input) {\n    deletedId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '85deff5ece472d902e89b6d6f4ba272e';
module.exports = node;
